import React from 'react';
import { TextAreaContainer, Label, StyledTextArea } from './TextArea.styles';

interface TextAreaProps extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
    label?: string;
}

export const TextArea: React.FC<TextAreaProps> = ({ label, ...props }) => {
    return (
        <TextAreaContainer>
            {label && <Label>{label}</Label>}
            <StyledTextArea {...props} />
        </TextAreaContainer>
    );
};
